<template>
    <div class="menu" :class="color">
        <b-container>
            <b-row>
                <b-col>
                    <b-navbar toggleable="lg" type="dark">
                        <router-link :to="{name: 'home'}"><img class="logo" src="../assets/logo.svg" alt="logo"></router-link>

                        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                        <b-collapse id="nav-collapse" is-nav>
                        
                            <!-- Right aligned nav items -->
                            <b-navbar-nav class="ml-auto">
                                <b-nav-item :to="{name: 'home'}">Inicio</b-nav-item>
                                <b-nav-item :to="{name: 'conocenos'}">Conócenos</b-nav-item>
                                <b-nav-item :to="{name: 'clientes'}">Clientes</b-nav-item>
                                <b-nav-item :to="{name: 'bolsatrabajo'}">Bolsa de trabajo</b-nav-item>
                                <b-nav-item :to="{name: 'contacto'}" class="btn-contact">Contáctanos</b-nav-item>
                            </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'menu',
        props: {
            color: {
                type: String,
                default: 'dark',
            },
        }
    }
</script>

<style scoped>
.ml-auto{
    margin-left: auto;
}
.menu{
    position:fixed;
    left: 0;
    width: 100%;
    z-index: 9999;
}
.menu{
    background: #001824;
}
.transparent{
    background: transparent;
}
/* NAVBAR */
.navbar{
    padding: 41px 0;
}
.nav-link{
    color: #fff;
    font-size: 20px;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

.nav-link:hover{
    color: #fff;
}

.nav-link.router-link-exact-active.router-link-active{
    color: #02FFF5 !important;
}
.btn-contact>.nav-link.router-link-exact-active.router-link-active{
    color: #FFF !important;
}
.btn-contact{
    background: #02FFF5;
    color: #FFF !important;
    border-radius: 3px;
}

.transparent .btn-contact,
.orange .btn-contact{
    background: #FC5300;
    color: #FFF !important;
    border-radius: 3px;
}
@media (max-width: 992px){
.transparent{
    background: #001824;
}
}
@media (max-width: 768px){
    .logo{
        width: 100px;
    }
    .navbar{
        padding: 15px 0;
    }
}
</style>